import { useAuth0 } from '@auth0/auth0-react';
import CircularProgress from "@mui/material/CircularProgress";
import { ReactComponent as AddIcon } from "assets/icons/add-plus.svg";
import FinanceService from 'Lib/API/Finance';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import AlertDialog from '../Dialog/AlertDialog';

const ManageAchCards = ({ 
  setSelectedAchCard, 
  selectedAchCard,
}) => {
  
  const { enqueueSnackbar } = useSnackbar();

  let accountID = localStorage.getItem("accountID")
  ? localStorage.getItem("accountID")
  : "";

  
  const [cardLoading, setCardLoading] = useState(false);
  const [cardList, setCardList] = useState([]);
  const [openAddCard, setOpenAddCard] = useState(false);

  const fetchAchCards = async () => {
    setCardLoading(true);
    const token = localStorage.getItem("token");
    await FinanceService.getACHCardsByAccountId(token, accountID)
      .then((res) => {
        setCardList(res?.ach?.data || []);
        if(res?.ach?.data?.length > 0 && !selectedAchCard) setSelectedAchCard(res?.ach?.data[0]?.id || "");
      })
      .catch((err) => {
        enqueueSnackbar(err?.data?.message, { variant: "error" });
      })
      .finally(() => {
        setCardLoading(false);
      });
  }

  useEffect(() => {
    if(!accountID) return;
    fetchAchCards();
  }, [accountID]);

  const openConfirmAddCard = () => {
    setOpenAddCard(true);
  }

  const closeConfirmAddCard = () => {
    setOpenAddCard(false);
  }

  const openAddAccountHandler = () => {
    setOpenAddCard(false);
    window.open("/settings/?tab=paymentMethods&activePayment=ach", "_blank");
  }


  return (
    <div className="card_num_field">
      {cardLoading ? (
        <div className="text-center">
        <CircularProgress />
        </div>
      ) : (
        <>
          {(!!cardList?.length && !cardLoading) ? (
            <div className="cards-radio font-16 d-flex flex-column items-center " style={{
              gap: "10px",
              width: "max-content",
            }}>
              {cardList?.map((item, index) => (
                <div
                  data-id={item.id}
                  key={item.id}
                  onClick={() => {
                    if (selectedAchCard === item.id) {
                      setSelectedAchCard("");
                    } else {
                      setSelectedAchCard(item.id);
                    }
                  }}
                  className={
                    selectedAchCard === item.id
                      ? "selected-card"
                      : ""
                  }
                  style={{ width: "100%" }}
                >
                  <p className='justify-content-between'>
                  {`${item.nameOnAccount ? item.nameOnAccount : ""} ${item.accountNumber ? "/ " + item.accountNumber : ""
                        }`}
                    <div className="checkbox checkbox-lg checkbox-single"
                      style={{ margin: "0 !important" }}
                    >
                      <input
                        type="checkbox"
                        name={`card_number${index}`}
                        id={index}
                        onChange={(e) => {
                          setSelectedAchCard(e.target?.checked ? item?.id : "");
                        }}
                        checked={
                          selectedAchCard === item?.id
                        }
                      />
                      <span />
                    </div>
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <div
              className="add-new-payment-info my-5"
              onClick={openConfirmAddCard}
            >
              <span className="add-icon">
                <AddIcon />
              </span>
              <span className="add">Add ACH account</span>
            </div>
          )}
        </>
      )}
      <AlertDialog
        open={openAddCard}
        onDecline={closeConfirmAddCard}
        onAccept={openAddAccountHandler}
        title={"Are you sure?"}
        description={"You will be redirected to the add ACH account page."}
      />
    </div>
  )
}

export default ManageAchCards